import { request } from './apiClient'

export const fetchHealth = () => request("GET", "/v1/health")
